import { useQuery } from '@tanstack/react-query';
import { getSitesSummary } from '../api/sitesApi';
import { useAuthStore } from '../../auth/stores/authStore';

export const sitesSummaryKeys = {
  all: ['sites', 'summary'] as const,
  list: (search?: string) => [...sitesSummaryKeys.all, { search }] as const,
};

/**
 * Query hook to fetch all sites in a lightweight summary format
 * Designed for dropdown/selection purposes (e.g., AddSitesPopover)
 * Returns all sites without pagination - use for components that need complete list
 */
export function useSitesSummary(search?: string) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: sitesSummaryKeys.list(search),
    queryFn: async () => {
      const result = await getSitesSummary(search);
      return result.sites || [];
    },
    enabled: isAuthenticated,
    staleTime: 30000, // 30 seconds
  });
}
